<template>
  <div>
    <Breadcrumbs title="Home"/>
    <div class="container-fluid">
      <div class="row second-chart-list third-news-update">
        <div class="col-xl-4 col-lg-12 xl-50 morning-sec box-col-12">
          <px-card class="profile-greeting">
            <div slot="with-padding">
              <div class="media">
                <div class="media-body">
                  <div class="greeting-user">
                    <h4 class="f-w-600 font-primary" id="greeting">{{ greeting }}</h4>
                    <p>Here whats happening in your account today</p>
<!--                    <div class="whatsnew-btn">-->
<!--                      <a href="javascript:void(0)" class="btn btn-primary">Whats New !</a>-->
<!--                    </div>-->
                  </div>
                </div>
                <div class="badge-groups">
                  <div class="badge f-10">
                    <feather type="clock" class="mr-1"></feather>
                    <span id="txt">{{ time }} <i class="flag-icon flag-icon-my"></i></span>
                  </div>
                </div>
              </div>
              <div class="cartoon"><img class="img-fluid" src="../assets/images/dashboard/cartoon.png" alt=""></div>
            </div>
          </px-card>
        </div>
        <div class="col-xl-8 xl-100 dashboard-sec box-col-12">
          <px-card class="earning-card">
            <div class="row m-0">
              <div class="col-xl-3 earning-content p-0">
                <div class="row m-0 chart-left">
                  <div class="col-xl-12 p-0 left_side_earning">
                    <h5>Dashboard</h5>
                    <p class="font-roboto">Overview of last month</p>
                  </div>
                  <div class="col-xl-12 p-0 left_side_earning">
                    <h5>$4055.56</h5>
                    <p class="font-roboto">This Month Earning</p>
                  </div>
                  <div class="col-xl-12 p-0 left_side_earning">
                    <h5>$1004.11</h5>
                    <p class="font-roboto">This Month Profit</p>
                  </div>
                  <div class="col-xl-12 p-0 left_side_earning">
                    <h5>90%</h5>
                    <p class="font-roboto">This Month Sale</p>
                  </div>
                  <div class="col-xl-12 p-0 left-btn">
                    <a class="btn btn-gradient">Summary</a>
                  </div>
                </div>
              </div>
              <div class="col-xl-9 p-0">
                <div class="chart-right">
                  <div class="row m-0 p-tb">
                    <div class="col-xl-8 col-md-8 col-sm-8 col-12 p-0">
                      <div class="inner-top-left">
                        <ul class="d-flex list-unstyled">
                          <li>Daily</li>
                          <li class="active">Weekly</li>
                          <li>Monthly</li>
                          <li>Yearly</li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-xl-4 col-md-4 col-sm-4 col-12 p-0 justify-content-end">
                      <div class="inner-top-right">
                        <ul class="d-flex list-unstyled justify-content-end">
                          <li>Online</li>
                          <li>Store</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-12">
                      <div class="card-body p-0">
                        <div class="current-sale-container">
                          <div id="chart-currently">
                            <apexchart
                                height="290"
                                type="area"
                                :options="apexDashboard.options"
                                :series="apexDashboard.series"
                            ></apexchart>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row border-top m-0">
                  <div class="col-xl-4 pl-0 col-md-6 col-sm-6">
                    <div class="media p-0">
                      <div class="media-left">
                        <i class="icofont icofont-crown"></i>
                      </div>
                      <div class="media-body">
                        <h6>Referral Earning</h6>
                        <p>$5,000.20</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 col-md-6 col-sm-6">
                    <div class="media p-0">
                      <div class="media-left bg-secondary">
                        <i class="icofont icofont-heart-alt"></i>
                      </div>
                      <div class="media-body">
                        <h6>Cash Balance</h6>
                        <p>$2,657.21</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 col-md-12 pr-0">
                    <div class="media p-0">
                      <div class="media-left">
                        <i class="icofont icofont-cur-dollar"></i>
                      </div>
                      <div class="media-body">
                        <h6>Sales forcasting</h6>
                        <p>$9,478.50</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </px-card>
        </div>
        <div class="col-xl-4 col-lg-12 xl-50 calendar-sec box-col-6">
          <px-card>
            <div slot="with-padding" class="chat-box">
              <div class="setting-dot">
                <div class="setting-bg-primary date-picker-setting position-set pull-right">
                  <i class="fa fa-spin fa-cog"></i>
                </div>
              </div>
              <functional-calendar></functional-calendar>
            </div>
          </px-card>
        </div>
        <div class="col-xl-4 xl-50 appointment box-col-6">
          <px-card :actions="false">
            <div slot="headerCustom">
              <div class="header-top">
                <h5 class="m-0">notification</h5>
                <div class="card-header-right-icon">
                  <select class="button btn btn-primary">
                    <option>Today</option>
                    <option>Tomorrow</option>
                    <option>Yesterday</option>
                  </select>
                </div>
              </div>
            </div>
            <div>
              <div class="radar-chart">
                <div id="marketchart">
                  <apexchart
                      height="380"
                      type="radar"
                      :options="apexMarketValue.options"
                      :series="apexMarketValue.series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </px-card>
        </div>
        <div class="col-xl-4 xl-50 appointment-sec box-col-6">
          <div class="row">
            <div class="col-xl-12">
              <px-card :actions="false" class="card-no-border">
                <div slot="headerCustom">
                  <div class="header-top">
                    <h5 class="m-0">Top {{ topSelect }}</h5>
                    <div class="card-header-right-icon">
                      <select class="button btn btn-primary" v-model="topSelect">
                        <option value="gain">Gainer</option>
                        <option value="lose">Loser</option>
                        <option value="volatile">Volatile</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="appointment-table table-responsive">
                    <table class="table table-bordernone">
                      <tbody v-if="topSelect==='gain'">
                      <tr :data="tr" :key="i" v-for="(tr, i) in gain">
                        <td class="img-content-box">
                          <span class="d-block">{{ tr.id }} {{ tr.name }}</span>
                          <span class="font-roboto">{{ Math.round(tr.market_cap/100)/10 }} M</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Today</span>
                          <span class="d-block">{{ tr.today_open }}</span>
                        </td>
                        <td>
                          <span :class="{ m0:true, 'font-success':parseFloat(tr.today_pct)>0, 'font-danger':parseFloat(tr.today_pct)<0 }"><b>{{ Math.round(tr.today_pct) }}%</b></span>
                          <span class="d-block">{{ tr.today_close }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Yester</span>
                          <span class="d-block">{{ tr.yesterday_open }}</span>
                        </td>
                        <td>
                          <span :class="{ m0:true, 'font-success':parseFloat(tr.yesterday_pct)>0, 'font-danger':parseFloat(tr.yesterday_pct)<0 }"><b>{{ Math.round(tr.yesterday_pct) }}%</b></span>
                          <span class="d-block">{{ tr.yesterday_close }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Week</span>
                          <span class="d-block">{{ tr.last_week_open }}</span>
                        </td>
                        <td>
                          <span :class="{ m0:true, 'font-success':parseFloat(tr.last_week_pct)>0, 'font-danger':parseFloat(tr.last_week_pct)<0 }"><b>{{ Math.round(tr.last_week_pct) }}%</b></span>
                          <span class="d-block">{{ tr.last_week_close }}</span>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-if="topSelect==='lose'">
                      <tr :data="tr" :key="i" v-for="(tr, i) in lose">
                        <td class="img-content-box">
                          <span class="d-block">{{ tr.id }} {{ tr.name }}</span>
                          <span class="font-roboto">{{ Math.round(tr.market_cap/100)/10 }} M</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Today</span>
                          <span class="d-block">{{ tr.today_open }}</span>
                        </td>
                        <td>
                          <span :class="{ m0:true, 'font-success':parseFloat(tr.today_pct)>0, 'font-danger':parseFloat(tr.today_pct)<0 }"><b>{{ Math.round(tr.today_pct) }}%</b></span>
                          <span class="d-block">{{ tr.today_close }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Yester</span>
                          <span class="d-block">{{ tr.yesterday_open }}</span>
                        </td>
                        <td>
                          <span :class="{ m0:true, 'font-success':parseFloat(tr.yesterday_pct)>0, 'font-danger':parseFloat(tr.yesterday_pct)<0 }"><b>{{ Math.round(tr.yesterday_pct) }}%</b></span>
                          <span class="d-block">{{ tr.yesterday_close }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Week</span>
                          <span class="d-block">{{ tr.last_week_open }}</span>
                        </td>
                        <td>
                          <span :class="{ m0:true, 'font-success':parseFloat(tr.last_week_pct)>0, 'font-danger':parseFloat(tr.last_week_pct)<0 }"><b>{{ Math.round(tr.last_week_pct) }}%</b></span>
                          <span class="d-block">{{ tr.last_week_close }}</span>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-if="topSelect==='volatile'">
                      <tr :data="tr" :key="i" v-for="(tr, i) in volatile">
                        <td class="img-content-box">
                          <span class="d-block">{{ tr.id }} {{ tr.stock }}</span>
                          <span class="font-roboto">{{ Math.round(tr.market_cap/100)/10 }} M</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Open</span>
                          <span class="d-block">{{ tr.open }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">High</span>
                          <span class="d-block">{{ tr.high }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Low</span>
                          <span class="d-block">{{ tr.low }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Close</span>
                          <span class="d-block">{{ tr.close }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">{{ tr.volatility }}</span>
                          <span :class="{ 'd-block':true, 'font-success':parseFloat(tr.volatility_pct)>5, 'font-danger':parseFloat(tr.volatility_pct)>20 }">{{ tr.volatility_pct }}</span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </px-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Userauth from '../auth/js/index'

var primary = localStorage.getItem('primary_color') || '#7366ff'
var secondary = localStorage.getItem('secondary_color') || '#f73164'

export default {
  data: function () {
    return {
      topSelect: 'gain',
      gain:[],
      lose:[],
      volatile:[],
      apexDashboard: {
        options: {
          chart: {
            width: 685,
            height: 240,
            type: 'area',
            toolbar: {
              show: false,
            },
          },
          colors: [primary, secondary],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
          },
          xaxis: {
            type: 'category',
            low: 0,
            offsetX: 0,
            offsetY: 0,
            show: false,
            categories: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'May',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Oct',
              'Nov',
              'Dec',
              'Jan',
            ],
            labels: {
              low: 0,
              offsetX: 0,
              show: false,
            },
            axisBorder: {
              low: 0,
              offsetX: 0,
              show: false,
            },
          },
          yaxis: {
            low: 0,
            offsetX: 0,
            offsetY: 0,
            show: false,
            labels: {
              low: 0,
              offsetX: 0,
              show: false,
            },
            axisBorder: {
              low: 0,
              offsetX: 0,
              show: false,
            },
          },
          markers: {
            strokeWidth: 3,
            colors: '#ffffff',
            strokeColors: [ primary , secondary ],
            hover: {
              size: 6,
            }
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.5,
              stops: [0, 80, 100]
            }
          },
          legend: {
            show: false,
          },
          tooltip: {
            x: {
              format: 'MM'
            },
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0,
              bottom: -15,
              top: -40
            }
          },
        },
        series: [
          {
            name: 'series1',
            data: [6, 20, 15, 40, 18, 20, 18, 23, 18, 35, 30, 55, 0],
          },
          {
            name: 'series2',
            data: [2, 22, 35, 32, 40, 25, 50, 38, 42, 28, 20, 45, 0],
          },
        ],
      },
      apexMarketValue: {
        options: {
          chart: {
            width: 505,
            height: 380,
            type: 'radar',
            toolbar: {
              show: false,
            },
          },
          colors: [primary],
          dataLabels: {
            enabled: false,
          },
          labels: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ],
          stroke: {
            width: 3,
            curve: 'smooth',
          },
          plotOptions: {
            radar: {
              size: 140,
              polygons: {
                fill: {
                  colors: ['#fcf8ff', '#f7eeff'],
                },
              },
            },
          },
          markers: {
            size: 6,
            colors: ['#fff'],
            strokeColor: [primary],
            strokeWidth: 3,
          },
          yaxis: {
            tickAmount: 7,
            labels: {
              formatter: function (val, i) {
                if (i % 2 === 0) {
                  return val;
                } else {
                  return '';
                }
              },
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val;
              },
            },
          },
        },
        series: [
          {
            name: 'Market value',
            data: [20, 100, 40, 30, 50, 80, 33],
          },
        ],
      },
      greeting : '',
      time : ''
    }
  },
  computed: {
    title: function () { return 'Home | Trade Winds' }
  },
  watch: {
    title: { immediate: true, handler() { document.title = this.title } },
    topSelect: function (val) {
      if(val === 'gain') this.fetchTopGain()
      if(val === 'lose') this.fetchTopLose()
      if(val === 'volatile') this.fetchTopVolatile()
    }
  },
  mounted() {
    this.$ua.trackView('Home', true)

    let d = new Date()
    let curHr = this.addZero(d.getHours())
    let curMi = this.addZero(d.getMinutes())
    let meridiem = curHr >= 12 ? 'PM' : 'AM'
    this.time = curHr + ':' + curMi + ' ' + meridiem
    if (curHr < 12) {
      this.greeting = 'Good morning!'
    } else if (curHr < 18) {
      this.greeting = 'Good afternoon!'
    } else {
      this.greeting = 'Good evening!'
    }

    this.init()
  },
  methods: {
    init() {
      this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')
      // this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.authentication.accessToken
      this.$http.get('/api/init')
          .then(({data}) => {
            let stockLinks = data.stocks.filter(s => s.category==='stock').map(s => ({ ...s, "path": "/stock/ticker/"+s.name, "title": `${s.id} ${s.name} - ${s.company} - RM ${s.open}`, "type": "link", "icon": "loader" }))
            this.$store.commit('menu/setStocks', stockLinks)
          })
          .catch(e => {
            if (e.response) {
              if (e.response.status >= 500) this.$ua.trackException('Login API Down', true)
              if (e.response.status === 401) {
                Userauth.logOut()
                // this.$router.push('/login')
              }
            } else if (e.request) {
              // console.log(e.request)
            } else {
              console.log('Error', e.message)
            }
            // console.log(e.config)
          })

      this.fetchTopGain()
    },
    addZero(i) {
      if (i < 10) {
        i = '0' + i
      }
      return i;
    },
    fetchTopGain() {
      this.$http.get('/api/stock/top/gain?limit=8')
          .then(({data}) => {
            this.gain = data.gain.map(g => ({ ...g, today_change:Math.round((g.today_change-1)*100)+'%', yesterday_change:Math.round((g.yesterday_change-1)*100)+'%', last_week_change:Math.round((g.last_week_change-1)*100)+'%' }))
            this.totalRowsG = this.gain.length
          })
          .catch(e => console.log(e.message))
    },
    fetchTopLose() {
      this.$http.get('/api/stock/top/lose?limit=8')
          .then(({data}) => {
            this.lose = data.lose.map(g => ({ ...g, today_change:Math.round((g.today_change-1)*100)+'%', yesterday_change:Math.round((g.yesterday_change-1)*100)+'%', last_week_change:Math.round((g.last_week_change-1)*100)+'%' }))
            this.totalRowsL = this.lose.length
          })
          .catch(e => console.log(e.message))
    },
    fetchTopVolatile() {
      this.$http.get('/api/stock/top/volatile?limit=8')
          .then(({data}) => {
            this.volatile = data.volatile.map(g => ({ ...g, volatility:Math.round(g.volatility*100)/100, volatility_pct:Math.round(g.volatility_pct*10)/10+'%' }))
            this.totalRowsV = this.volatile.length
          })
          .catch(e => console.log(e.message))
    },
  }
}
</script>